import { render, staticRenderFns } from "./iybr-global-ids-collapsible.vue?vue&type=template&id=c6b856c8"
import script from "./iybr-global-ids-collapsible.ts?vue&type=script&lang=ts&external"
export * from "./iybr-global-ids-collapsible.ts?vue&type=script&lang=ts&external"
import style0 from "./iybr-global-ids-collapsible.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6b856c8')) {
      api.createRecord('c6b856c8', component.options)
    } else {
      api.reload('c6b856c8', component.options)
    }
    module.hot.accept("./iybr-global-ids-collapsible.vue?vue&type=template&id=c6b856c8", function () {
      api.rerender('c6b856c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/in-year-budget-requests/create-in-year-budget-request/create-iybr-form/iybr-global-ids-collapsible/iybr-global-ids-collapsible.vue"
export default component.exports